import { SelfServiceBanner } from '@vp/selfservice-ui'
import { Box, ResponsiveImage, Typography } from '@vp/swan'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import LeftArrowIcon from '../../assets/images/left_arrow.svg'
import './ReplacementArticle.scss'

interface ReplacementArticleProps {
  locale: string
  tenant: string
  onShowSelfService: (shown: boolean) => void
  helpCenterUrl: string
  handleBackBtnClick: () => void
}
export const ReplacementArticle = (props: ReplacementArticleProps) => {
  const { locale, tenant, onShowSelfService, helpCenterUrl, handleBackBtnClick } = props
  const lng = locale.toLowerCase().replace('-', '_')

  const { t } = useTranslation(tenant)
  const [shouldShowBackButton, setShouldShowBackButton] = useState(true)

  return (
    <>
      {shouldShowBackButton && (
        <Box onClick={handleBackBtnClick} className="article-back-container">
          <Box mr="3" style={{ display: 'inline-flex' }}>
            <ResponsiveImage role="presentation" src={LeftArrowIcon} alt="" height="10px" />
          </Box>
          <Typography fontSize="small" fontWeight="bold">
            {t('articles.links.back', { lng })}
          </Typography>
        </Box>
      )}
      <Box>
        <SelfServiceBanner
          locale={locale}
          tenant={tenant}
          origin="HC-Article"
          type="embedded"
          onCTAClick={() => {
            setShouldShowBackButton(false)
          }}
          executeOnlyFlowEnd
          onFlowEnd={async () => {
            window.location.href = helpCenterUrl
          }}
          onFlowClose={async () => {
            setShouldShowBackButton(true)
          }}
          onBannerHidden={() => onShowSelfService(false)}
          onBannerShown={() => onShowSelfService(true)}
        />
      </Box>
    </>
  )
}
